import {NgModule} from '@angular/core';
import {FileExportsComponent} from './file-exports.component';
import {NgxPermissionsModule} from 'ngx-permissions';
import {RouterModule} from '@angular/router';
import {TableModule} from 'primeng/table';
import {LoadingModule} from 'ngx-loading';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../pipes/pipes.module';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule, MatInputModule, MatSelectModule} from '@angular/material';
import {routes} from './file-exports.routing';

@NgModule({
    imports: [
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        TableModule,
        LoadingModule,
        CommonModule,
        PipesModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule
    ],
    declarations: [
        FileExportsComponent
    ]
})
export class FileExportsModule { }


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/file-exports/file-exports.module.ts